export class SsoAuthenticationResult {
    public idToken: string;
    public idp?: string;
}